function getEmbeddedRedirectUrl(url: string) {
    const token = window.Glide?.authBearer ?? '';
    return `${window.location.origin}/embedded_redirect/?viewUrl=${
        encodeURIComponent(url)}&embeddedSessionToken=${token}`
}

export default getEmbeddedRedirectUrl;
